export const STICKY_AI_QUESTION_HEIGHT = 40
